import React from 'react';
import { Link } from 'react-router-dom';
import { LoginFooter } from '../Common/LoginFooter';
import {BuyerSidebar} from '../Common/BuyerSidebar';
import { Header } from '../Common';
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class BuyerEstimateAlt extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            minHeight: "475px"
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        // console.log('asd')
        e.preventDefault();
        let data = {
            
        }
        console.log(data);
        // this.props.buyerLogin(data);
    }

    render() {
        return (
            <div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12" >
                            <div className="">
                                <Header />
                            </div>
                        </div>
                        {/* <div className="col-md-12"> */}
                        <div className="container">
                        <div>&nbsp;</div>
                            <div className="row mt-5" style={{minHeight: this.state.minHeight}}>
                            <div></div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-4 input_name">
                                            <BuyerSidebar />
                                        </div>
                                        <div className="col-md-8">
                                            <div className="top-div">
                                                <h3>Buyer transaction</h3>
                                                <table className="chest">
                                                    <tbody>
                                                        <tr>
                                                            <td className="navigation" style={{borderTop: "4px solid #67b1e2", borderBottom: "1px solid white"}}>
                                                                <Link to={'/buyer-estimate'} className="h-a" href=""><b>Estimate</b></Link>
                                                            </td>
                                                            <td className="navigation">
                                                                <Link to={'/buyer-transaction'} className="h-a" href="">During Trading</Link>
                                                            </td>
                                                            <td className="navigation">
                                                                <Link to={'/buyer-complete-cancel'} className="h-a" href="">Complete / Cancel</Link>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="3">
                                                                <div className="min-height ml-3">
                                                                   <div className="col-md-12 row" style={{borderBottom: "1px solid #ddd", paddingBottom: "2%"}}>
                                                                        <div className="col-md-6 font_12" style={{textAlign: "left"}}>Consultation content</div>
                                                                        <div className="col-md-2 font_12" style={{textAlign: "left"}}>Deadline for proposal</div>
                                                                        <div className="col-md-2 font_12" style={{textAlign: "left"}}>Budget guide</div>
                                                                        <div className="col-md-2 font_12" style={{textAlign: "left"}}>status</div>
                                                                   </div>
                                                                   <div className="col-md-12 row" style={{borderBottom: "1px solid #ddd", paddingBottom: "2%", paddingTop: "2%"}}>
                                                                        <div className="col-md-6 font_12" style={{textAlign: "left"}}>Estimated consultation (via profile) No. 226406<br/>
                                                                        <h6>card design</h6></div>
                                                                        <div className="col-md-2 font_12" style={{textAlign: "left"}}>2019/6/11</div>
                                                                        <div className="col-md-2 font_12" style={{textAlign: "left"}}>5,000 yen to <br/>10,000 yen</div>
                                                                        <div className="col-md-2 font_12" style={{textAlign: "left"}}><div style={{border: "1px solid green", padding: "3%", color: "green"}}>Proposed / not purchased</div></div>
                                                                   </div>
                                                                   <div className="col-md-12 row" style={{borderBottom: "1px solid #ddd", paddingBottom: "2%", paddingTop: "2%", background: "#efecec"}}>
                                                                        <div className="col-md-6 font_12" style={{textAlign: "left"}}>
                                                                        <img style={{borderRadius: "50%"}} alt="" src={require("../../assets/images/image1.jpeg")} height="45%" width='14%'/>&nbsp;
                                                                        Murakami Lab<br/>
                                                                        </div>
                                                                        <div className="col-md-2 font_12" style={{textAlign: "left"}}>Expected completion date 2019/6/18</div>
                                                                        <div className="col-md-2 font_12" style={{textAlign: "left"}}>Estimated price 7,000 yen</div>
                                                                        <div className="col-md-2 font_12" style={{textAlign: "left"}}>Deadline for purchase 2019/6/17</div>
                                                                   </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>                                       
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 mt-5" >
                    <div className=" mt-5">
                        <LoginFooter />
                    </div>
                </div>
            </div>
        );
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { BuyerEstimateAlt };